var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2501 32.85V4.04998C7.2501 3.20128 7.58724 2.38735 8.18736 1.78723C8.78747 1.18712 9.6014 0.849976 10.4501 0.849976H23.2501C24.0988 0.849976 24.9127 1.18712 25.5128 1.78723C26.113 2.38735 26.4501 3.20128 26.4501 4.04998V32.85M7.2501 32.85H26.4501M7.2501 32.85H4.0501C3.2014 32.85 2.38747 32.5128 1.78736 31.9127C1.18724 31.3126 0.850098 30.4987 0.850098 29.65V20.05C0.850098 19.2013 1.18724 18.3874 1.78736 17.7872C2.38747 17.1871 3.2014 16.85 4.0501 16.85H7.2501M26.4501 32.85H29.6501C30.4988 32.85 31.3127 32.5128 31.9128 31.9127C32.513 31.3126 32.8501 30.4987 32.8501 29.65V15.25C32.8501 14.4013 32.513 13.5874 31.9128 12.9872C31.3127 12.3871 30.4988 12.05 29.6501 12.05H26.4501M13.6501 7.24998H20.0501M13.6501 13.65H20.0501M13.6501 20.05H20.0501M13.6501 26.45H20.0501",
    stroke: "#565D6D",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon);
export default __webpack_public_path__ + "static/media/facility-icon.4868ee3063dbbbf986e0df27f23e6426.svg";
export { ForwardRef as ReactComponent };